// import AsyncStorage from '@react-native-async-storage/async-storage';
import { Action, combineReducers, configureStore, Middleware, PayloadAction, ThunkAction } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';
import undoable, { excludeAction, groupByActionTypes, includeAction } from 'redux-undo';
import { saveObject } from '../components/menu/SaveLoad';
import advanceReducer from './slices/AdvanceSlice';
import gameObjectReducer, { GameObject } from './slices/gameObjectSlice';
import instaReducer, { setDisplay, setImagesLikes, setInsta, setInstaImage, setSelectedImage, setSelectedProfile, setUserName } from './slices/instaSlice';
import menuReducer from './slices/menuSlice';
import phoneReducer, { setHistory, setPhoneDisplay, showMessagesUI } from './slices/phoneSlice';
import savesReducer from './slices/savesSlice';
import soundsReducer from './slices/soundsSlice';

const lastActionType = { current: null }; // Create a ref-like object

const actionListenerMiddleware: Middleware = (store) => (next) => (action) => {
    lastActionType.current = action.type;
    return next(action);
};
export const createStore = (actionListenerMiddleware: Middleware, history?: { past: GameObject[], present: GameObject, future: GameObject[]; }) => {

    // const persistConfig: PersistConfig<CombinedState<any>> = {
    //     version: 1,
    //     key: "root",
    //     timeout: undefined,
    //     throttle: 1000,
    //     storage: AsyncStorage,
    //     blacklist: ['menu', 'phone', 'insta']
    // };
    const combinedReducer = combineReducers({
        gameObject: undoable(gameObjectReducer, {
            limit: 100,

            undoType: 'GAME_OBJECT_UNDO',
            redoType: 'GAME_OBJECT_REDO',
            clearHistoryType: 'GAME_OBJECT_CLEAR',
            syncFilter: true,
            filter: excludeAction(["reset", "gameObject/setVersion", "gameObject/removeSound", "GAME_OBJECT_CLEAR"])
        }),
        advance: advanceReducer,
        saves: savesReducer,
        sounds: soundsReducer,
        menu: menuReducer,
        phone: undoable(phoneReducer, {
            limit: 50,
            undoType: 'PHONE_UNDO',
            jumpToPastType: "PHONE_PAST",
            jumpToFutureType: 'PHONE_FUTURE',
            redoType: 'PHONE_REDO',
            clearHistoryType: 'PHONE_CLEAR',
            syncFilter: true,
            groupBy: groupByActionTypes([setPhoneDisplay.type, showMessagesUI.type, setHistory.type]),
            filter: includeAction([setPhoneDisplay.type])
        }),
        insta: undoable(instaReducer, {
            limit: 50,
            undoType: 'INSTA_UNDO',
            jumpToPastType: "INSTA_PAST",
            jumpToFutureType: 'INSTA_FUTURE',
            redoType: 'INSTA_REDO',
            clearHistoryType: 'INSTA_CLEAR',
            // filter: includeAction([setInsta.type])
            syncFilter: true,
            filter: includeAction([setInsta.type,]),
            groupBy: groupByActionTypes([setSelectedImage.type, setSelectedProfile.type, setDisplay.type, setUserName.type, setImagesLikes.type, setInstaImage.type])

        }),
    });

    const rootReducer = (state: any, action: PayloadAction<saveObject | undefined>) => {
        if (action.type === 'reset') {
            if (action.payload) {

                state = { advance: state.advance, menu: state.menu, ...action.payload };
            } else {
                // state = { advance: state.advance, menu: state.menu, gameObject: { ...state.gameObject, present: { ...state.gameObject.present, version: Game.version } } };
                state = { advance: state.advance, menu: state.menu };
            }
        }
        return combinedReducer(state, action);
    };

    // const rootReducer = combineReducers(reducers);
    const logger: Middleware = store => next => (action: Action) => {

        return next(action);
    };

    // const persistedReducer = persistReducer(persistConfig, rootReducer);
    const store = configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: false,
                immutableCheck: false


            }).concat(logger)
                .concat(actionListenerMiddleware), // Add the middleware here

    });
    return { store, rootReducer, actionListenerRef: lastActionType }; // Return the ref
};

export const { store, rootReducer, actionListenerRef } = createStore(actionListenerMiddleware);


export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof rootReducer>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
